import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { accountInformation } from '../../../services/index';

export const fetchUserAccountInformation = createAsyncThunk(
  'user/fetchAccountInformation',
  async () => {
    const response = await accountInformation();
    return response.data;
  },
);

const slice = createSlice({
  name: 'user',
  initialState: {
    userAccountDetails: {},
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserAccountInformation.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUserAccountInformation.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.userAccountDetails = action.payload;
      })
      .addCase(fetchUserAccountInformation.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default slice.reducer;
